const { upgradeArray } = require('../utils')

const { SENDING_STATUS } = require('./_sendings')

const SENDINGS_FALLBACKS_STATES = upgradeArray([ 'created', 'ready', 'processing', 'done', 'failed', 'expired' ])
const SENDINGS_FALLBACKS_OPTIONS_CLEAN = {
  onStatus: [],
  onTimeout: {
    timeout: undefined,
    except: []
  },
  onIncomingPayload: {
    text: undefined
  }
}
const SENDINGS_FALLBACKS_OPTIONS_DEFAULT = {
  onStatus: [ SENDING_STATUS.failed ],
  onTimeout: {
    timeout: 50,
    except: [ SENDING_STATUS.delivered, SENDING_STATUS.seen ]
  }
}

module.exports = {
  SENDINGS_FALLBACKS_STATES,
  SENDINGS_FALLBACKS_OPTIONS_CLEAN,
  SENDINGS_FALLBACKS_OPTIONS_DEFAULT
}
